export default __webpack_public_path__ + "static/media/playerprofile.0810b5b3.png";